import { BrowserModule } from '@angular/platform-browser';
import { NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { ColorPickerModule } from 'ngx-color-picker';.
import { HttpClientModule } from '@angular/common/http';
import { LaddaModule } from 'angular2-ladda';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { SchedulerComponent } from './components/scheduler/scheduler.component';
import { PopupComponent } from './components/popup/popup.component';
import { ScreenBuilderComponent } from './components/screen-builder/screen-builder.component';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './guards';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { HeaderComponent } from './components/header/header.component';
import { AppSettingsService } from './services/app-settings.service';
import { ScreenService } from './services/screen.service';
import { RegistrationService } from './services/Registration.service';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { DataService } from './services/data.service';
import { SafePipe } from './safe.pipe';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { UserService } from './services/user.service';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { APP_INITIALIZER } from '@angular/core';
import { HttpModule } from '@angular/http';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SubscriptionService } from './services/subscription.service';
//import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup
//import { MomentModule } from 'angular2-moment'; // optional, provides moment-style pipes for date formatting
import { SubscriptionComponent } from './components/subscription/subscription.component';

export function initConfig(config: AppSettingsService) {
  return () => config.load();
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SchedulerComponent,
    ScreenBuilderComponent,
    PopupComponent,
    HeaderComponent,
    SafePipe,
    SubscriptionComponent
  ],
  imports: [
    BrowserModule,
   // NgIdleKeepaliveModule.forRoot(),
    //MomentModule,
   // UserIdleModule.forRoot({idle: 30, timeout: 30, ping: 120}),
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    LaddaModule.forRoot({
      style: 'slide-down'
    }),
    Ng4LoadingSpinnerModule.forRoot(),
    AppRoutingModule,
    NgbModule.forRoot(),
    SimpleNotificationsModule.forRoot(),
    DropzoneModule,
    Ng2DeviceDetectorModule.forRoot(),
    HttpModule,
    NgxSliderModule
  ],
  providers: [
    AuthGuard,
    AppSettingsService,
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [AppSettingsService],
      multi: true
    },
    AuthService,
    ScreenService,
    DataService,
    UserService,
    RegistrationService,
    SubscriptionService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }


// WEBPACK FOOTER //
// ./src/app/app.module.ts